export var Provider;
(function (Provider) {
    Provider["BigQuery"] = "bigquery";
    Provider["Redshift"] = "redshift";
    Provider["Postgres"] = "postgres";
    Provider["Snowflake"] = "snowflake";
    Provider["DatabricksRest"] = "databricksRest";
    //Databricks = 'databricks'
})(Provider || (Provider = {}));
export var Language;
(function (Language) {
    Language["SQL"] = "sql";
    Language["Python"] = "python";
})(Language || (Language = {}));
export var TokenAllowedApis;
(function (TokenAllowedApis) {
    TokenAllowedApis["maps"] = "maps";
    TokenAllowedApis["sql"] = "sql";
    TokenAllowedApis["imports"] = "imports";
    TokenAllowedApis["lds"] = "lds";
    TokenAllowedApis["workflows"] = "workflows";
    TokenAllowedApis["batch"] = "batch";
    TokenAllowedApis["httpRequest"] = "httpRequest";
    TokenAllowedApis["resources"] = "resources";
})(TokenAllowedApis || (TokenAllowedApis = {}));
export var WorkflowComponentParamType;
(function (WorkflowComponentParamType) {
    WorkflowComponentParamType["InputTable"] = "Table";
    WorkflowComponentParamType["OutputTable"] = "OutputTable";
    WorkflowComponentParamType["Column"] = "Column";
    WorkflowComponentParamType["Number"] = "Number";
    WorkflowComponentParamType["String"] = "String";
    WorkflowComponentParamType["StringSql"] = "StringSql";
    WorkflowComponentParamType["Boolean"] = "Boolean";
    WorkflowComponentParamType["Selection"] = "Selection";
    WorkflowComponentParamType["SelectionType"] = "SelectionType";
    WorkflowComponentParamType["Json"] = "Json";
    WorkflowComponentParamType["GeoJson"] = "GeoJson";
    WorkflowComponentParamType["GeoJsonDraw"] = "GeoJsonDraw";
    WorkflowComponentParamType["Condition"] = "Condition";
    WorkflowComponentParamType["Range"] = "Range";
    WorkflowComponentParamType["ColumnNumber"] = "ColumnNumber";
    WorkflowComponentParamType["SelectColumnNumber"] = "SelectColumnNumber";
    WorkflowComponentParamType["SelectColumnType"] = "SelectColumnType";
    WorkflowComponentParamType["SelectColumnAggregation"] = "SelectColumnAggregation";
    WorkflowComponentParamType["Email"] = "Email";
})(WorkflowComponentParamType || (WorkflowComponentParamType = {}));
export var WorkflowComponentParameterMode;
(function (WorkflowComponentParameterMode) {
    WorkflowComponentParameterMode["Radio"] = "radio";
    WorkflowComponentParameterMode["Slider"] = "slider";
    WorkflowComponentParameterMode["Toggle"] = "toggle";
    WorkflowComponentParameterMode["Multiple"] = "multiple";
    WorkflowComponentParameterMode["Multiline"] = "multiline";
})(WorkflowComponentParameterMode || (WorkflowComponentParameterMode = {}));
export var WorkflowCodeType;
(function (WorkflowCodeType) {
    WorkflowCodeType["Full"] = "Full";
    WorkflowCodeType["FullNoCache"] = "FullNoCache";
    WorkflowCodeType["DryRun"] = "DryRun";
    WorkflowCodeType["StoredProcedure"] = "StoredProcedure";
})(WorkflowCodeType || (WorkflowCodeType = {}));
export var WorkflowComponentOutputType;
(function (WorkflowComponentOutputType) {
    WorkflowComponentOutputType["Table"] = "Table";
    WorkflowComponentOutputType["View"] = "View";
})(WorkflowComponentOutputType || (WorkflowComponentOutputType = {}));
/**
 * The type of a value used as a component parameter, defining its origin
 */
export var WorkflowComponentValueType;
(function (WorkflowComponentValueType) {
    WorkflowComponentValueType["Node"] = "Node";
    WorkflowComponentValueType["Literal"] = "Literal";
})(WorkflowComponentValueType || (WorkflowComponentValueType = {}));
export var WorkflowComponentIconTypes;
(function (WorkflowComponentIconTypes) {
    WorkflowComponentIconTypes["Default"] = "Default";
    WorkflowComponentIconTypes["Success"] = "Success";
    WorkflowComponentIconTypes["Failure"] = "Failure";
    WorkflowComponentIconTypes["Executed"] = "Executed";
    WorkflowComponentIconTypes["Configured"] = "Configured";
})(WorkflowComponentIconTypes || (WorkflowComponentIconTypes = {}));
export var WorkflowParameterValueErrorType;
(function (WorkflowParameterValueErrorType) {
    WorkflowParameterValueErrorType["WrongValue"] = "wrongvalue";
    WorkflowParameterValueErrorType["MissingValue"] = "missingvalue";
})(WorkflowParameterValueErrorType || (WorkflowParameterValueErrorType = {}));
export var ColumnDataType;
(function (ColumnDataType) {
    ColumnDataType["Number"] = "number";
    ColumnDataType["String"] = "string";
    ColumnDataType["Boolean"] = "boolean";
    ColumnDataType["Geometry"] = "geometry";
    ColumnDataType["Geography"] = "geography";
    ColumnDataType["Date"] = "date";
    ColumnDataType["Time"] = "time";
    ColumnDataType["Datetime"] = "datetime";
    ColumnDataType["Timestamp"] = "timestamp";
    ColumnDataType["Binary"] = "binary";
})(ColumnDataType || (ColumnDataType = {}));
export var TableOptimizationColumnDataType;
(function (TableOptimizationColumnDataType) {
    TableOptimizationColumnDataType["NonGeo"] = "nongeo";
    TableOptimizationColumnDataType["Geo"] = "geo";
})(TableOptimizationColumnDataType || (TableOptimizationColumnDataType = {}));
export var ConditionType;
(function (ConditionType) {
    ConditionType["Equal"] = "=";
    ConditionType["NotEqual"] = "!=";
    ConditionType["GreaterThan"] = ">";
    ConditionType["GreaterThanOrEqual"] = ">=";
    ConditionType["LessThan"] = "<";
    ConditionType["LessThanOrEqual"] = "<=";
    ConditionType["Contains"] = "contains";
    ConditionType["Null"] = "IS NULL";
    ConditionType["True"] = "IS TRUE";
    ConditionType["False"] = "IS FALSE";
})(ConditionType || (ConditionType = {}));
export var IsolinesProviders;
(function (IsolinesProviders) {
    IsolinesProviders["Here"] = "here";
    IsolinesProviders["Mapbox"] = "mapbox";
    IsolinesProviders["Mock"] = "mock";
    IsolinesProviders["TomTom"] = "tomtom";
    IsolinesProviders["TravelTime"] = "traveltime";
})(IsolinesProviders || (IsolinesProviders = {}));
export var RoutingMatrixProviders;
(function (RoutingMatrixProviders) {
    RoutingMatrixProviders["Mock"] = "mock";
    RoutingMatrixProviders["TomTom"] = "tomtom";
    RoutingMatrixProviders["TravelTime"] = "traveltime";
})(RoutingMatrixProviders || (RoutingMatrixProviders = {}));
